module.exports = "/_next/static/images/EduHub-265269a4ddc97d225fcd8c1e066273b2.jpg";